/* Global Theme JavaScript */

// Basic cart functionality
class CartDrawer {
  constructor() {
    this.cart = null;
    this.init();
  }

  async init() {
    await this.getCart();
  }

  async getCart() {
    try {
      const response = await fetch('/cart.js');
      this.cart = await response.json();
      return this.cart;
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  }

  async updateCart(updates) {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates })
      });
      this.cart = await response.json();
      return this.cart;
    } catch (error) {
      console.error('Error updating cart:', error);
    }
  }
}

// Initialize cart
window.cartDrawer = new CartDrawer();

// Handle forms
document.addEventListener('DOMContentLoaded', () => {
  // Add to cart forms
  const addToCartForms = document.querySelectorAll('form[action*="/cart/add"]');
  
  addToCartForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const formData = new FormData(form);
      const data = {
        id: formData.get('id'),
        quantity: parseInt(formData.get('quantity') || 1)
      };
      
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data)
        });
        
        if (response.ok) {
          // Redirect to cart or show success message
          window.location.href = '/cart';
        } else {
          const error = await response.json();
          alert(error.description || 'Error adding to cart');
        }
      } catch (error) {
        console.error('Error:', error);
        alert('Error adding to cart');
      }
    });
  });
});
